(function() {
  'use strict';

  angular.module('mgpCorregedoriaApp', [
    'mgpCorregedoriaApp.validacao',
    'mgpCorregedoriaApp.info'
  ]).run(Run);

  function Run($rootScope, amMoment) {

    amMoment.changeLocale('pt-BR');

    $rootScope.$on("$viewContentLoaded", function() {
      if ($('.left-bar').hasClass('stash')) {
        $('.right-side').addClass('stash');
        $('.content').addClass('stash');
      }
    });
  }

})();